// extracted by mini-css-extract-plugin
export default {"productGrid":"tZ-z","centerLink":"uZ-z","productSection":"vZ-z","item":"wZ-z","ctaButton":"xZ-z"};